import React, { useState } from 'react';
import type { DebugGamePerformanceResult } from '../../services/gamePerformanceService';
import styles from './GamePerformanceDebugPanel.module.css';

interface GamePerformanceDebugPanelProps {
	debugResult: DebugGamePerformanceResult;
}

const GamePerformanceDebugPanel: React.FC<GamePerformanceDebugPanelProps> = ({ debugResult }) => {
	const [expanded, setExpanded] = useState(false);

	const matchedComponents = debugResult.componentMatches.filter(m => m.matchedPerformanceName !== null);

	return (
		<div className={styles.panel}>
			<button className={styles.toggle} onClick={() => setExpanded(!expanded)}>
				{expanded ? '[-]' : '[+]'} Debug: Game Performance
			</button>

			{expanded && (
				<div className={styles.content}>
					<div>
						<strong>Component Matches:</strong>
						{matchedComponents.map((m, i) => (
							<div key={i} className={styles.matchItem}>
								{m.componentType}: {m.matchedPerformanceName} (val: {m.performanceValue})
							</div>
						))}
					</div>

					{debugResult.games.map((game, i) => (
						<div key={i} className={styles.gameItem}>
							<strong>{game.title}</strong> → {game.status}
							{game.components.map((c, j) => (
								<div key={j} className={styles.componentItem}>
									{c.componentType}: <strong>{matchedComponents.find(m => m.componentType === c.componentType)?.matchedPerformanceName ?? '?'}={c.yourValue ?? '?'}</strong>, minimum={c.minimumName ?? '?'}({c.minimumValue ?? '?'}), recommended={c.recommendedName ?? '?'}({c.recommendedValue ?? '?'}) → {c.status}
								</div>
							))}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default GamePerformanceDebugPanel;